<template>
  <ec-chart :option="state.option" :version="state.key" style="width: 100%; height: 260px"></ec-chart>
</template>
<script lang="ts" setup>
import { reactive, watch } from "vue"
import EcChart from "./EcLegacyChart.vue"
import { EChartsOption } from "echarts"
import { v4 as uuid } from "uuid"

export interface PieData {
  value: string
  title: string
}

const props = defineProps<{
  data: Array<PieData>
  title: string
}>()

const state = reactive({
  option: {} as EChartsOption,
  key: uuid(),
})

const getOption = async () => {
  const pieData = []
  for (const product of props.data) {
    pieData.push({
      name: product.title,
      value: product.value,
    })
  }

  state.option = {
    tooltip: {
      trigger: "item",
      formatter: (params: any) => {
        const { name, value, percent } = params
        return `${name}: ￥${value} (${percent}%)`
      },
    },
    grid: {
      top: 0, // 减小顶部边距（默认可能是 20% 或更多）
      bottom: 36, // 底部边距
      right: 24, // 右侧边距
      left: 24, // 左侧边距（确保 Y 轴标签不被裁剪）
    },
    legend: {
      orient: "horizontal",
      left: "center",
      top: "bottom",
    },
    series: [
      {
        name: props.title,
        type: "pie",
        radius: "55%",
        center: ["50%", "40%"],
        data: pieData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  } as EChartsOption
  state.key = uuid()
}

watch(
  () => props.data,
  () => {
    getOption()
  },
  {
    immediate: true,
  }
)
</script>
